var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWheelchair = function SvgIconWheelchair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.865 3.75c0 1.236-.78 2.29-1.875 2.696V8h5a1 1 0 1 1 0 2h-5v1.75h7.25a1 1 0 0 1 .895.553l2.612 5.224 1.427-.476a1 1 0 0 1 .633 1.898l-2.25.75a1 1 0 0 1-1.211-.502l-2.724-5.447H8.99a1 1 0 0 1-1-1v-2.433a5.001 5.001 0 1 0 6.383 6.566 1 1 0 1 1 1.853.753A6.999 6.999 0 1 1 7.99 8.223V6.446a2.876 2.876 0 1 1 3.875-2.696M8.99 2.875a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconWheelchair;